import DubfShowcaseBrowser from './DubfShowcaseBrowser';
import DubfShowcasePhone from './DubfShowcasePhone';
import GutmannShowcaseBrowser from './GutmannShowcaseBrowser';
import GutmannShowcasePhone from './GutmannShowcasePhone';
import MakeyourdayShowcaseBrowser from './MakeyourdayShowcaseBrowser';
import MakeyourdayShowcasePhone from './MakeyourdayShowcasePhone';
import SchweizerIllustrierteShowcaseBrowser from './SchweizerIllustrierteShowcaseBrowser';
import SchweizerIllustrierteShowcasePhone from './SchweizerIllustrierteShowcasePhone';
import WallboardShowcase from './WallboardShowcase';
import WaveBlockShowcase from './WaveBlockShowcase';
import YwamShowcaseBrowser from './YwamShowcaseBrowser';
import YwamShowcasePhone from './YwamShowcasePhone';

export default {
  DubfShowcaseBrowser,
  DubfShowcasePhone,
  GutmannShowcaseBrowser,
  GutmannShowcasePhone,
  MakeyourdayShowcaseBrowser,
  MakeyourdayShowcasePhone,
  SchweizerIllustrierteShowcaseBrowser,
  SchweizerIllustrierteShowcasePhone,
  WallboardShowcase,
  WaveBlockShowcase,
  YwamShowcaseBrowser,
  YwamShowcasePhone,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Device/devices/index.ts